import React,{Component} from 'react'
import { connect } from "react-redux"

import { withRouter } from 'react-router-dom'
import {Link, NavLink } from 'react-router-dom'

import AdminMenu from './AdminMenu'
import NavItem from '../NavItem'

const $ = window.$;
// Setup
function miniSidebar() {
    if ($('body').hasClass('sidebar-xs')) {
        $('.sidebar-main.sidebar-fixed .sidebar-content').on('mouseenter', function () {
            if ($('body').hasClass('sidebar-xs')) {

                // Expand fixed navbar
                $('body').removeClass('sidebar-xs').addClass('sidebar-fixed-expanded');
            }
        }).on('mouseleave', function () {
            if ($('body').hasClass('sidebar-fixed-expanded')) {

                // Collapse fixed navbar
                $('body').removeClass('sidebar-fixed-expanded').addClass('sidebar-xs');
            }
        });
    }
}

// Nice scroll
// ------------------------------

// Setup
function initScroll() {
    $(".sidebar-fixed .sidebar-content").niceScroll({
        mousescrollstep: 100,
        cursorcolor: '#ccc',
        cursorborder: '',
        cursorwidth: 3,
        hidecursordelay: 100,
        autohidemode: 'scroll',
        horizrailenabled: false,
        preservenativescrolling: false,
        railpadding: {
            right: 0.5,
            top: 1.5,
            bottom: 1.5
        }
    });
}

// Remove
function removeScroll() {
    $(".sidebar-fixed .sidebar-content").getNiceScroll().remove();
    $(".sidebar-fixed .sidebar-content").removeAttr('style').removeAttr('tabindex');
}

function reInitSidebar(){
    $('.navigation').find('li').has('ul').children('a').addClass('has-ul');

    $('.navigation-main').find('li').has('ul').children('a').unbind("click");
    $('.navigation-main').find('li').has('ul').children('a').on('click', function (e) {
        e.preventDefault();

        // Collapsible
        $(this).parent('li').not('.disabled').not($('.sidebar-xs').not('.sidebar-xs-indicator').find('.navigation-main').children('li')).toggleClass('active').children('ul').slideToggle(250);

        // Accordion
        if ($('.navigation-main').hasClass('navigation-accordion')) {
            $(this).parent('li').not('.disabled').not($('.sidebar-xs').not('.sidebar-xs-indicator').find('.navigation-main').children('li')).siblings(':has(.has-ul)').removeClass('active').children('ul').slideUp(250);
        }
    });
}

class SideBar extends Component{
    constructor(props){
        super(props);

    }
    componentWillReceiveProps(newProps){
        console.log(newProps);
    }
    componentDidMount(){

    }
    componentDidUpdate(){
        // Initialize
        miniSidebar();
        reInitSidebar();

        // Toggle mini sidebar
        $('.sidebar-main-toggle').on('click', function (e) {

            // Initialize mini sidebar
            miniSidebar();
        });

        // Initialize Scroll
        initScroll();

        // Remove scrollbar on mobile
        $(window).on('resize', function() {
            setTimeout(function() {
                if($(window).width() <= 768) {

                    // Remove nicescroll on mobiles
                    removeScroll();
                }
                else {

                    // Init scrollbar
                    initScroll();
                }
            }, 100);
        }).resize();
    }

    isActive(match, location){


        console.log(match, location);
    }
    render(){
        let { profile,companies } = this.props;
        if (!profile.isAuth) {
            return null;
        }

        return(
            <div className="sidebar sidebar-main">
                <div className="sidebar-content">
                    <div className="sidebar-category sidebar-category-visible">
                        <div className="category-content no-padding">
                            <ul className="navigation navigation-main navigation-accordion">
                                <NavItem to={`/`}>
                                    <i className="icon-stack"></i> <span>Мониторинг</span>
                                </NavItem>

                                <NavItem  to={`/company`}>
                                    <i className="icon-link"></i> <span>Привязки</span>
                                </NavItem>

                                {
                                    (profile.roles.indexOf("Admin") !== -1) ?
                                        <AdminMenu/>
                                        :null
                                }
                            </ul>
                        </div>
                    </div>


                </div>
            </div>
        );
    }
}
function mapStateToProps(state) {
    return {
        profile: state.profile,
        companies: state.companies
    }
}



export default  withRouter(connect(mapStateToProps)(SideBar));



// WEBPACK FOOTER //
// ./src/components/Shared/SideBar/index.jsx